import React, { useState, useEffect, useRef } from 'react';
import { chartColorScheme, eventStatusOptions, getDateRangeISO } from '../AccountLevelReportConstant';
import { getOrganiserReports } from '../../../../revampCRUD/accountLevelReports.crud';
import FilterDropdown from '../EventsSummary/FilterDropdown';
import { dashboardColors, theme } from '../../../../themes/Theme';
import LoadingSpinner from '../../../../revampComponents/Atom/Loading';
import PaymentStatsCard from '../PaymentAnalytics/PaymentStatsCard';
import customToast from '../../../../components/common/basic/Toast';
import CustomDateRangeModal from '../EventsSummary/CustomDateRangeModal';


const PaymentGatewaysOverview = ({ 
    selectedCurrency = null,
    dateFilterOptions = [],
    eventStatusOptions = [],
    eventStatus = "past",
    dateFilter = "lastWeek",
    paymentGatewayData = { gateways: [], methods: [] },
    loading = false,
    onDateFilterChange = () => { },
    onEventStatusChange = () => { },
    customDateRange = { startDate: null, endDate: null, isActive: false },
    onCustomDateChange = () => { } }) => 
    {
    const [openDateModal, setOpenDateModal] = useState(false);
    const modalRef = useRef(null);

    const handleDateFilterChange = (option) => {
        if (option?.value === 'custom') {
            setOpenDateModal(true);
        } else {
            onDateFilterChange(option);
        }
    };

    const handleCustomDateProceed = (selectedDates) => {
        setOpenDateModal(false);
        const customOption = {
            value: 'custom',
            startDate: selectedDates?.startDate,
            endDate: selectedDates?.endDate
        };
        onDateFilterChange(customOption);
    };

    return (
        <div className="payment-gateways-overview d-flex flex-column richtext-gap-3">
            <div className="gateways-header ">
                <h3 className="gateways-title">Payment Gateways Used</h3>

                <div className="gateways-filters">
                    <FilterDropdown
                        options={dateFilterOptions}
                        value={dateFilter}
                           onChange={handleDateFilterChange}
                        onCustomSelect={() => setOpenDateModal(true)}
                        placeholder="Last Week"
                        className="gateway-filter"
                    />

                    <FilterDropdown
                        options={eventStatusOptions || []}
                        value={eventStatus}
                         onChange={onEventStatusChange}
                        placeholder="Active"
                        className="gateway-filter"
                    />

                </div>

            </div>
             <CustomDateRangeModal
                ref={modalRef}
                isOpen={openDateModal}
                onClose={() => {
                    setOpenDateModal(false);
                }}
                onProceed={handleCustomDateProceed}
                timeZone="UTC"
                initialStartDate={customDateRange?.startDate || null}
                initialEndDate={customDateRange?.endDate || null}
            />
            {loading ? <LoadingSpinner height={200} /> : <div></div>}
            <div className="w-100">
                <PaymentStatsCard
                    data={paymentGatewayData?.gateways || []}
                    colorScheme={chartColorScheme}
                    loading={loading}
                    heading='overview'
                />
          </div>
           
            <style jsx>{`
        .payment-gateways-overview {
          padding: 20px;
          box-shadow: 0px 0px 20px 9px #002E6E24;
          border-radius: 4px;
          background-color: #fff;
          margin-bottom: 2rem;
          height:100%;
        }

        .gateways-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .gateways-title {
          font-size: 18px;
          font-weight: 600;
          color: ${dashboardColors[theme].primaryTextColor};
          margin: 0;
        }

        .gateways-filters {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
        }

        .gateway-filter {
          min-width: 120px;
        }

     
        
      `}</style>
        </div>
    );
};

export default PaymentGatewaysOverview;
